import { useDrop } from "react-dnd";
import { Overlay, canMoveOrderTo, moveOrderTo } from "./dragDrop";
import { useAppDispatch } from "../../app/hooks";

/*
group
name
members
*/
export default function DropWrapper({ container, children }) {
  console.log(container);
  const dispatch = useAppDispatch();
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: "OrderCard",
      canDrop: () => canMoveOrderTo(container),
      drop: () => moveOrderTo(container, dispatch),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
      }),
    }),
    [container, dispatch]
  );

  return (
    <div style={{ position: "relative" }} ref={drop}>
      {children}
      {isOver && canDrop && <Overlay color="rgba(0, 0, 0, 0.6)" />}
    </div>
  );
}
